import { mediaData } from '@/mocks/home';

export default function MediaSection() {
  const handleScroll = (href: string) => {
    const el = document.querySelector(href);
    if (el) {
      el.scrollIntoView({ behavior: 'smooth' });
    }
  };

  return (
    <section id="media" className="w-full py-16 md:py-20 bg-background-50">
      <div className="max-w-[1200px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading text-2xl md:text-3xl text-foreground-900 mb-3">
            吃瓜视频
          </h2>
          <p className="text-sm text-foreground-500">热门黑料吃瓜视频精选推荐</p>
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
          {mediaData.slice(0, 3).map((item) => (
            <button
              key={item.id}
              onClick={() => handleScroll('#cards')}
              className="group flex flex-col bg-background-100 rounded-2xl overflow-hidden border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer text-left"
            >
              <div className="relative aspect-video overflow-hidden">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    const parent = target.parentElement;
                    target.style.display = 'none';
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-12 h-12 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-xl ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-900/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-4">
                <h3 className="font-heading text-sm md:text-base text-foreground-800 mb-1 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {item.title}
                </h3>
                <div className="flex items-center justify-between">
                  <p className="text-xs text-foreground-500 line-clamp-1">{item.desc}</p>
                  <span className="text-xs text-foreground-400 whitespace-nowrap ml-2">{item.views} 播放</span>
                </div>
              </div>
            </button>
          ))}
        </div>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-5 mt-5">
          {mediaData.slice(3).map((item) => (
            <button
              key={item.id}
              onClick={() => handleScroll('#cards')}
              className="group flex flex-col sm:flex-row bg-background-100 rounded-2xl overflow-hidden border border-secondary-200/40 hover:border-primary-200 transition-all duration-200 cursor-pointer text-left"
            >
              <div className="relative w-full sm:w-60 aspect-video sm:aspect-auto overflow-hidden flex-shrink-0">
                <img
                  src={item.image}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                  onError={(e) => {
                    const target = e.currentTarget;
                    const parent = target.parentElement;
                    target.style.display = 'none';
                    if (parent) {
                      parent.style.display = 'none';
                    }
                  }}
                />
                <div className="absolute inset-0 bg-black/20 flex items-center justify-center">
                  <div className="w-10 h-10 rounded-full bg-background-50/90 flex items-center justify-center group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200">
                    <i className="ri-play-fill text-lg ml-0.5"></i>
                  </div>
                </div>
                <span className="absolute bottom-2 right-2 px-2 py-0.5 rounded-md bg-foreground-900/70 text-background-50 text-xs font-medium">
                  {item.duration}
                </span>
              </div>
              <div className="p-5 flex flex-col justify-center flex-1">
                <h3 className="font-heading text-sm md:text-base text-foreground-800 mb-2 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-sm text-foreground-500 leading-relaxed mb-3">{item.desc}</p>
                <span className="text-xs text-foreground-400">{item.views} 播放</span>
              </div>
            </button>
          ))}
        </div>
      </div>
    </section>
  );
}